'use client'

import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useSession } from '@marketplace-web/shared/session-data'
import { getSellerBadgesList } from '@marketplace-web/seller-engagement-tools/seller-engagement-tools-data'

type Props = {
  user:
    | {
        id: number
        business: boolean
      }
    | undefined
}

const useFetchSellerBadgesList = ({ user }: Props) => {
  const { data: sellerBadgesList, fetch: fetchSellerBadgesList } = useFetch(getSellerBadgesList)
  const { id: currentUserId, business: isCurrentUserBusiness } = useSession().user || {}
  const { id: userId, business } = user || {}

  const isViewingSelf = currentUserId === userId
  const bothUsersNotBusiness = !isCurrentUserBusiness && !business

  const shouldFetchSellerBadgesList = !isViewingSelf && bothUsersNotBusiness

  useEffect(() => {
    if (!userId) return

    if (shouldFetchSellerBadgesList) fetchSellerBadgesList(userId)
  }, [fetchSellerBadgesList, isViewingSelf, shouldFetchSellerBadgesList, user, userId])

  return {
    sellerBadgesList: sellerBadgesList?.badges,
  }
}

export default useFetchSellerBadgesList
